import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { Users, Truck, Building2, Caravan, Warehouse, ArrowRight } from "lucide-react";

const ROLES = [
  { title: "Drivers", copy: "Find transportation opportunities.", icon: Users, href: "#drivers" },
  { title: "Owner Operators", copy: "Find qualified driver assistance for your truck.", icon: Truck, href: "#owner-operators" },
  { title: "Carriers", copy: "Expand driver coverage and manage relay operations.", icon: Building2, href: "#carriers" },
  { title: "RV Owners", copy: "Request authorized RV recovery or delivery.", icon: Caravan, href: "#rv" },
  { title: "RV Dealers & Fleets", copy: "Manage vehicle delivery, transfers and repositioning.", icon: Warehouse, href: "#rv" },
];

export const WhoItsFor = () => {
  return (
    <section data-testid="who-its-for-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading eyebrow="Who RelayRigs Is For" title="One Platform. Five Ways to Use It." align="center" testId="who-its-for" />

        <RevealStagger className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {ROLES.map((role) => (
            <RevealItem key={role.title}>
              <a
                href={role.href}
                data-testid={`role-card-${role.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group block bg-rr-navy rounded-2xl p-6 h-full min-h-[220px] flex flex-col justify-between hover:bg-rr-orange transition-colors duration-300"
              >
                <role.icon size={28} className="text-rr-orangeLight group-hover:text-white transition-colors" />
                <div>
                  <h4 className="font-heading font-bold text-white text-lg mt-6">{role.title}</h4>
                  <p className="text-white/50 group-hover:text-white/80 text-xs mt-2">{role.copy}</p>
                  <ArrowRight size={16} className="text-white mt-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </a>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
};
